import React, { use, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { FETCH_ERROR, FETCH_START, FETCH_SUCCESS } from '../../constants/ActionTypes';
import customAxios from '../../util/Api';
import authHeader from '../../../../services/auth/jwt/auth-header';
import { useToast } from 'context/tostifyContext';
import { event } from 'jquery';
import { useAllUsers } from 'context/AllUserDataContext';
import useConfirmationDialog from 'routes/Pages/components/ConfirmDialogs/useConfirmationDialog';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { array } from 'prop-types';
import { toLocalISO } from 'routes/Pages/GenTask/components/SharedFormFields';
import { set } from 'lodash';

const DEFAULT_VARIABLE_DATA = {
  hectares: 0, //site vol in Hectares
  treesPerHectare: 0, // m3PerHec /  conversionFactor
  averageTree: 0,
  conversionFactor: 1.15,
  m3PerHectare: 0,
  tonnesPerHectare: 0,
  totalM3: 0,
  totalTons: 0,
  lpgRate: 1.2,
};
const DEFAUKT_TABLE_COL = {
  siteAssessmentID: 0,
  spNumber: 'string',
  pricingVersion: 'string',
  product: 'string',
  destination: 'string',
  productPercent: 0,
  tonnes: 0,
  price: 0,
  chipping: 0,
  doubleHandling: 0,
  haulage: 0,
  extractionCosts: 0,
  harvestingCostsPerTonne: 0,
  purchasesPrice: 0,
  salesPrice: 0,
  totalCosts: 0,
  profitPerTonne: 0,
};

const formatter = new Intl.NumberFormat('en-GB');

// HELPERS
const loadGoogleMaps = () =>
  new Promise((resolve, reject) => {
    if (window.google?.maps) return resolve();

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyA94J1dEXShLTlOZmIZbmOT31Qyo2g-2OU`;
    script.async = true;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });

const getRouteDistanceKm = async (origin, destination) => {
  try {
    await loadGoogleMaps();

    const service = new window.google.maps.DirectionsService();

    return new Promise((resolve, reject) => {
      service.route(
        {
          origin,
          destination: { lat: destination?.latitude, lng: destination.longitude }, // { lat, lng }
          travelMode: window.google.maps.TravelMode.DRIVING,
        },
        (result, status) => {
          if (status === 'OK') {
            const meters = result.routes[0].legs[0].distance.value;
            resolve(Number((meters / 1000).toFixed(1)));
          } else {
            reject(status);
          }
        },
      );
    });
  } catch (err) {
    console.error('Google Directions API error:', err);
    return null;
  }
};
const getEntrance = mapCoordinates => {
  if (!Array.isArray(mapCoordinates)) return null;

  const entrance = mapCoordinates.find(p => p.mapLabel?.toLowerCase().includes('entrance') || p.mapType === 'entrance');

  if (!entrance) return null;

  console.log('ENTRANCE =====', entrance);

  return {
    lat: Number(entrance.latitude),
    lng: Number(entrance.longitude),
  };
};

const useTimberSalesPriceController = parms => {
  const { siteAssessmentId: currSiteAssessment, pricingVersion: currPricingVersion } = parms;
  const dispatch = useDispatch();
  const { showToast } = useToast();

  // Add a ref to track if locations are being fetched
  const isLoadingLocations = useRef(false);
  const allLocationDataRef = useRef([]);

  const [allSiteAssesments, setAllSiteAssesments] = useState([]);
  const [selectedSiteAssesment, setSeletedSiteAssesment] = useState(null);
  //varaiables
  const [siteAssessmentVariables, setSiteAssesmentVariables] = useState(DEFAULT_VARIABLE_DATA); //default
  const [siteAssesmentUpdateVariables, setSiteAssessmnetUpdateVariables] = useState(DEFAULT_VARIABLE_DATA); //to update

  const [selectedSiteInfo, setSelectedSiteInfo] = useState({});
  const history = useHistory();
  //products data
  const [selectedSiteProducts, setSelectedSiteProducts] = useState([]);

  //const new data structure for siteTavble
  const [salesPricingData, setSalesPricingData] = useState([]);

  //haulageData
  const [haulagePricingData, setHaulagePricingData] = useState([]);
  const [entranceMapCoordinates, setEntranceMapcoordinates] = useState([]);
  const [allLocationData, setAllLocationData] = useState([]);
  const [currentSpNumber, setCurrentSpNumber] = useState(false);

  //final price
  const [fullPriceForSite, setFullPriceForsSite] = useState({
    totalPurchaseSumOfAllProduct: 0,
    totalProfitSumOfAllProduct: 0,
    totalSalesSumOfAllProduct: 0,
    totalProductionCostSumOfAllProduct: 0,
    totalHFCostAllProduct: 0,
  });

  //product dropDownKeys
  const [productListOptions, setProductListOptions] = useState([
    'Comm',
    'Pallet',
    'Stake',
    'Pulp/Brash',
    'Brash',
    'Firewood',
    'Hurley Butts',
    'Biomass',
    'Pulp/Biomas',
  ]);

  const [productConformationDialog, setProductConformationDialog] = useState(false);
  const [currentProduct, setCurrentProduct] = useState(0);

  const [showPrevVersions, setShowPrevVersions] = useState(false);
  const [prevVersions, setPrevVersions] = useState([]);

  const [rateParams, setRateParams] = useState([
    {
      fuelCurrentRate: 175,
      fuelBaseRate: 120,
      baseRatePercent: 100,
      subContractorRate: 70,
      tonnesPerLoad: 28,
      rateChangePercent: 0,
      haulageCategoryId: 0,
    },
  ]);
  const [haulgeCategoryOptions, setHaulageCategoryOptions] = useState([]);

  const {
    openConfirmationDialog,
    setOpenConfirmationDialog,
    handleOpenConfirmationDialog,
    confirmationDialogProps,
    closeConfirmationDialog,
  } = useConfirmationDialog();

  useEffect(async () => {
    if (currPricingVersion && currSiteAssessment) {
      getSingularSiteAssesment();
    } else {
      getAllSiteAssesments();
    }
    getProductListOpt();
    console.log(currSiteAssessment, parms);
  }, []);

  useEffect(() => {
    if (selectedSiteInfo?.mapCoordinates) {
      getAllLocationData(null, selectedSiteInfo.mapCoordinates); // ✅ pass it explicitly
    }
  }, [selectedSiteInfo?.mapCoordinates]);

  useEffect(() => {
    getHeaderInfoData();
    getSiteInfo();
  }, [selectedSiteAssesment]);

  useEffect(() => {
    try {
      let total = 0;
      let totalObj = {
        totalPurchaseSumOfAllProduct: 0,
        totalProfitSumOfAllProduct: 0,
        totalSalesSumOfAllProduct: 0,
        totalProductionCostSumOfAllProduct: 0,
        totalHFCostAllProduct: 0,
      };

      console.log('Sales pricn ====', salesPricingData, salesPricingData[0]['totalHF']);
      for (let i = 0; i < salesPricingData.length; i++) {
        console.log(salesPricingData[i]['totalCostPerProductIncludingAll'], 'data');
        totalObj.totalProductionCostSumOfAllProduct += salesPricingData[i]['totalCostPerProductIncludingAll']
          ? parseFloat(salesPricingData[i]['totalCostPerProductIncludingAll'].replace(/,/g, ''))
          : 0;

        totalObj.totalPurchaseSumOfAllProduct += salesPricingData[i]['totalPurchasePricePerProducts']
          ? parseFloat(salesPricingData[i]['totalPurchasePricePerProducts'].replace(/,/g, ''))
          : 0;

        totalObj.totalSalesSumOfAllProduct += salesPricingData[i]['totalSalesPerProduct']
          ? parseFloat(salesPricingData[i]['totalSalesPerProduct'].replace(/,/g, ''))
          : 0;

        totalObj.totalHFCostAllProduct += salesPricingData[i]['totalHFCostPerProduct']
          ? parseFloat(salesPricingData[i]?.['totalHFCostPerProduct'].replace(/,/g, ''))
          : 0;

        totalObj.totalProfitSumOfAllProduct += salesPricingData[i]['totalProfitPerProduct']
          ? parseFloat(salesPricingData[i]['totalProfitPerProduct'].replace(/,/g, ''))
          : 0;
      }
      totalObj = {
        totalPurchaseSumOfAllProduct: formatter.format(totalObj.totalPurchaseSumOfAllProduct.toFixed(0)),
        totalProfitSumOfAllProduct: formatter.format(totalObj.totalProfitSumOfAllProduct.toFixed(0)),
        totalSalesSumOfAllProduct: formatter.format(totalObj.totalSalesSumOfAllProduct.toFixed(0)),
        totalProductionCostSumOfAllProduct: formatter.format(totalObj.totalProductionCostSumOfAllProduct.toFixed(0)),
        totalHFCostAllProduct: formatter.format(totalObj.totalHFCostAllProduct.toFixed(0)),
      };
      setFullPriceForsSite(totalObj);
    } catch (ex) {
      console.log(ex);
    }
  }, [salesPricingData]);

  useEffect(() => {
    const fetchTimberPricing = async () => {
      try {
        const res = await customAxios.get(
          `/Ops/GetTimberPricing/?siteAssessmentID=${currSiteAssessment}&pricingVersion=${currPricingVersion}`,
          { headers: authHeader() },
        );

        const spNumber = res.data[0]?.spNumber ?? '';

        if (spNumber === '') {
          setCurrentSpNumber(true);
        } else {
          setCurrentSpNumber(false);
        }
      } catch (error) {
        console.error('Error fetching timber pricing:', error);
      }
    };

    // Only fetch if both IDs are available
    if (currSiteAssessment && currPricingVersion) {
      fetchTimberPricing();
    }
  }, [currSiteAssessment, currPricingVersion]);

  useEffect(() => {
    const prevTimberPricingVersions = async () => {
      try {
        const response = await customAxios.get(`/Ops/GetTimberPricing?siteAssessmentID=${currSiteAssessment}`, {
          headers: authHeader(),
        });

        if (response.status === 200) {
          const grouped = {};

          response.data.forEach(item => {
            const version = item.pricingVersion;

            if (!grouped[version]) {
              grouped[version] = {
                pricingVersion: version,
                siteAssessmentID: item.siteAssessmentID,
                timberPricingLabel: item.timberPricingLabel,
                totalTonnes: item.totalTonnes,
                totalM3: item.totalM3,
                products: 0,
              };
            }

            grouped[version].products += 1;
          });

          const versions = Object.values(grouped)
            .filter(v => v.pricingVersion !== currPricingVersion)
            .sort((a, b) => {
              const aNum = Number(a.pricingVersion.split('-')[1]);
              const bNum = Number(b.pricingVersion.split('-')[1]);
              return bNum - aNum;
            });

          setPrevVersions(versions);
        }
      } catch (error) {
        console.log(error);
      }
    };

    prevTimberPricingVersions();
  }, [currSiteAssessment, currPricingVersion]);

  useEffect(() => {
    const fetchRateParams = async () => {
      try {
        const { data } = await customAxios.get(`/Ops/GetFuelParameters`, { headers: authHeader() });
        if (data?.length > 0) setRateParams(data);
        else
          setRateParams([
            {
              fuelCurrentRate: 175,
              fuelBaseRate: 120,
              baseRatePercent: 100,
              subContractorRate: 70,
              tonnesPerLoad: 28,
              rateChangePercent: 0,
              haulageCategoryId: 0,
            },
          ]);
      } catch (error) {
        console.log(error);
      }
    };
    fetchRateParams();
  }, [currSiteAssessment]);

  useEffect(() => {
    const fetchHaulageCategories = async () => {
      try {
        const { data } = await customAxios.get(`/Ops/GetHaulageCategory`, { headers: authHeader() });
        setHaulageCategoryOptions(formatHaulageOptions(data));
      } catch (error) {
        console.log(error);
      }
    };
    fetchHaulageCategories();
  }, [currSiteAssessment]);

  const formatHaulageOptions = data => {
    const defaultOption = { label: 'Standard', value: 0 };

    const options = data.map(item => {
      const hasPCT = item.priceChangePCT !== null && item.priceChangePCT !== 0;
      const hasAdj = item.priceChangeAdj !== null && item.priceChangeAdj !== 0;

      let suffix = '';
      if (hasPCT) suffix = `(${item.priceChangePCT}%)`;
      else if (hasAdj) suffix = `(€${item.priceChangeAdj})`;

      return {
        label: `${item.haulageCategory} ${suffix}`.trim(),
        value: item.id,
      };
    });

    return [defaultOption, ...options];
  };

  const handleHaulageCategoryChange = async (haulageCategoryId, colIndex) => {
    console.log('HAULAGE CATEGORY ======', haulageCategoryId, colIndex);

    const row = salesPricingData[colIndex];
    const dest = row?.destination || row?.defaultDestination;
    const distanceKm = getDistanceKmByName(dest)?.distanceKm ?? 0;

    // Store the selected category ID immediately
    handleSalesPriceDataChange('haulageCategory', haulageCategoryId, colIndex);

    try {
      const payload = {
        distance: distanceKm,
        ...rateParams[0],
        haulageCategoryID: haulageCategoryId,
      };
      const { data } = await customAxios.post(`/Ops/GetCalculatedHaulageRates`, payload, { headers: authHeader() });

      // Store the full response for tooltip display
      setSalesPricingData(prev => {
        const newData = [...prev];
        newData[colIndex] = {
          ...newData[colIndex],
          haulageCategory: haulageCategoryId,
          haulage: parseFloat(data.actual_Rate ?? 0),
          haulageDetails: data,
          haulageManuallySet: false, // ← category change = auto rate again
        };
        return newData;
      });

      // Recalculate totals by triggering a dummy update
      handleSalesPriceDataChange('haulage', parseFloat(data.actual_Rate ?? 0), colIndex);
    } catch (err) {
      console.error('Error fetching haulage rate:', err);
    }
  };

  const getDistanceKmByName = destinationName => {
    if (!destinationName || !allLocationData?.length) return 0;

    const loc = allLocationData.find(d => d.destinationName === destinationName);

    return loc;
  };

  const getSingularSiteAssesment = async () => {
    customAxios
      .get(`/CRM/GetCRMSiteDetails/?siteAssessmentId=${currSiteAssessment}`, { headers: authHeader() })
      .then(data => {
        if (data.status == 200) {
          if (data.data.length > 0) {
            let correctedData = data.data;
            setAllSiteAssesments(correctedData);
            if (currSiteAssessment && currPricingVersion) {
              let currAssessment = correctedData.filter(item => item.siteAssessmentID == currSiteAssessment);
              console.log(currAssessment);
              if (currAssessment.length == 0) {
                return;
              }

              if (currAssessment[0].wH_Number) {
                customAxios
                  .get(`/Ops/GetContracts?contractUniqueID=${currAssessment[0].wH_Number}`, { headers: authHeader() })
                  .then(contractData => {
                    if (contractData.status == 200) {
                      const contract = contractData.data[0];
                      setSeletedSiteAssesment({
                        ...currAssessment[0],
                        contractUniqueID: contract?.contractUniqueID ?? '',
                        wh_numberName: contract?.wH_NumberName ?? '',
                      });
                    } else {
                      setSeletedSiteAssesment(currAssessment[0]);
                    }
                  });
              } else {
                setSeletedSiteAssesment(currAssessment[0]);
              }
            }
          }
        }
      });
  };

  const getAllLocationData = async (locationName, mapCoordinates) => {
    let url = '/CRM/GetAllCustomerLocations';
    if (locationName) {
      url = '/CRM/GetCustomerLocations/' + locationName;
    }

    const response = await customAxios.get(url, { headers: authHeader() });
    if (response.status !== 200) return;

    const locations = response.data;
    allLocationDataRef.current = locations;

    if (locationName) {
      return locations;
    }

    const routeResponse = await customAxios.get(`/SiteDetails/GetSiteDetailsMapRoutes/${currSiteAssessment}`, {
      headers: authHeader(),
    });

    const routeData = routeResponse?.data ?? [];
    const routeDistanceMap = new Map();
    routeData.forEach(route => {
      if (route.destination && route.distance != null) {
        routeDistanceMap.set(route.destination, route.distance);
      }
    });

    // ✅ Use passed-in mapCoordinates, fall back to state
    const coords = mapCoordinates ?? selectedSiteInfo?.mapCoordinates;
    const entrance = getEntrance(coords);

    if (!entrance) {
      console.log('⏳ Entrance not ready, skipping location setup');
      return;
    }

    await loadGoogleMaps();

    const locationsWithDistance = await Promise.all(
      locations.map(async loc => {
        const latitude = Number(loc?.latitude);
        const longitude = Number(loc?.longitude);

        // 🥇 PRIORITY 1 — backend modified distance
        if (routeDistanceMap.has(loc.destinationName)) {
          return {
            ...loc,
            distanceKm: routeDistanceMap.get(loc.destinationName),
            distanceSource: 'route',
          };
        }

        // ❌ Invalid coords → no Google call
        if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
          return {
            ...loc,
            distanceKm: 0,
            distanceSource: 'none',
          };
        }

        // 🥈 PRIORITY 2 — Google Maps
        try {
          const destination = { latitude, longitude };
          console.log('eee ===', entrance, destination);
          const distanceKm = await getRouteDistanceKm(entrance, destination);

          return {
            ...loc,
            distanceKm,
            distanceSource: 'google',
          };
        } catch (err) {
          return {
            ...loc,
            distanceKm: 0,
            distanceSource: 'error',
          };
        }
      }),
    );

    setAllLocationData(locationsWithDistance);
    allLocationDataRef.current = locationsWithDistance;
  };

  const getProductListOpt = () => {
    customAxios.get('/Ops/GetProducts', { headers: authHeader() }).then(data => {
      if (data.status == 200) {
        console.log(data.data);
        let productList = [];
        for (let i = 0; i < data.data.length; i++) {
          productList.push(data.data[i]['productName']);
        }
        setProductListOptions(productList);
      }
    });
  };
  const fillSalesPriceTableData = async (productData, distanceData) => {
    console.log(productData, 'prod');
    try {
      dispatch({ type: FETCH_START });

      if (selectedSiteAssesment && productData && productData.length > 0 && !currPricingVersion) {
        // Ensure locations are loaded
        if (allLocationDataRef.current.length === 0) {
          console.log('⏳ Locations not loaded yet, loading now...');
          await getAllLocationData();

          // Recalculate distanceData now that locations are loaded
          distanceData = await getHaulagePricingData(
            productData.map(p => ({ productsDestination: p.productsDestination })),
            selectedSiteInfo?.mapCoordinates,
            selectedSiteInfo?.geolocations,
          );
          if (distanceData) {
            distanceData = distanceData.sort((itemA, itemB) => itemA.index - itemB.index);
          }
          setHaulagePricingData(distanceData);
        }

        const tableInfoArr = [];
        for (let i = 0; i < productData.length; i++) {
          let product = productData[i];

          let haulagePrices = distanceData ? distanceData.filter(item => item.index == i) : [];
          haulagePrices = haulagePrices.length > 0 ? haulagePrices[0] : 0;
          if (haulagePrices) {
            haulagePrices =
              haulagePrices['fuelRate'] && haulagePrices['fuelRate']['rateA'] ? haulagePrices['fuelRate']['rateA'] : 0;
          }

          const currItem = {
            siteAssessmentID: selectedSiteAssesment.siteAssessmentID,
            spNumber: selectedSiteAssesment.wH_Number,
            pricingVersion: '',
            product: product.stockCode,
            defaultDestination: product.productsDestination,
            destination: product.productsDestination,
            productPercent: product.productsPercent,
            pricePerTon: product.productsPricePerTonne,
            tonnes: 0,
            price: product.price,
            chipping: 0,
            doubleHandling: 0,
            haulage: haulagePrices,
            extractionCosts: 0,
            harvestingCostsPerTonne: 0,
            purchasesPrice: 0,
            salesPrice: 0,
            totalCosts: 0,
            profitPerTonne: 0,
            total: haulagePrices,
            totalProfit: -haulagePrices,
            totalProfitPercentage: 0,
            totalPurchasePricePerProducts: 0,
            totalProfitPerProduct: 0,
            totalSalesPerProduct: 0,
            totalCostPerProductIncludingAll: 0,
            totalHFCostPerProduct: 0,
          };
          tableInfoArr.push(currItem);
        }
        for (let i = productData.length; i < 15; i++) {
          const currItem = {
            siteAssessmentID: selectedSiteAssesment.siteAssessmentID,
            spNumber: selectedSiteAssesment.wH_Number,
            pricingVersion: '',
            product: null,
            defaultDestination: '',
            destination: '',
            productPercent: '',
            pricePerTon: '',
            tonnes: 0,
            price: 0,
            chipping: 0,
            doubleHandling: 0,
            haulage: 0,
            extractionCosts: 0,
            harvestingCostsPerTonne: 0,
            purchasesPrice: 0,
            salesPrice: 0,
            totalCosts: 0,
            profitPerTonne: 0,
            total: 0,
            totalProfit: 0,
            totalProfitPercentage: 0,
            totalPurchasePricePerProducts: 0,
            totalProfitPerProduct: 0,
            totalSalesPerProduct: 0,
            totalCostPerProductIncludingAll: 0,
            totalHFCostPerProduct: 0,
          };
          tableInfoArr.push(currItem);
        }
        console.log(tableInfoArr, 'prod');
        setSalesPricingData(tableInfoArr);

        dispatch({ type: FETCH_SUCCESS });
      } else {
        fillEditSalesPriceTable(productData, distanceData);
      }
    } catch (Ex) {
      console.log(Ex);
      dispatch({ type: FETCH_ERROR, payload: 'Error updating table data' });
    }
  };

  const fillEditSalesPriceTable = async (mapCords, geoLocations) => {
    try {
      const response = await customAxios.get(
        `/Ops/GetTimberPricing/?siteAssessmentID=${currSiteAssessment}&pricingVersion=${currPricingVersion}`,
        { headers: authHeader() },
      );

      if (response.status == 200) {
        let data = response.data;
        console.log('data ===', data);
        let distanceDestinationObj = [];
        let obj = {
          hectares: 0,
          treesPerHectare: 0, // m3PerHec /  conversionFactor
          averageTree: 0,
          conversionFactor: 1.15,
          m3PerHectare: 0,
          tonnesPerHectare: 0,
          totalM3: 0,
          totalTons: 0,
          lpgRate: 1.2,
        };
        for (let i = 0; i < data.length; i++) {
          distanceDestinationObj.push({ productsDestination: data[i]['destination'] });
        }
        if (data.length > 0) {
          let item = data[0];
          obj = {
            hectares: item.hectares,
            treesPerHectare: item.treesPerHectare, // m3PerHec /  conversionFactor
            averageTree: item.avgTreeVol,
            conversionFactor: item.conversionFactor,
            m3PerHectare: item.m3PerHectare,
            tonnesPerHectare: item.tonnesPerHectare,
            totalM3: item.totalM3,
            totalTons: item.totalTonnes,
            lpgRate: item.lpgRate === 0 ? 1.2 : item.lpgRate,
          };
          setSiteAssessmnetUpdateVariables(obj);
        }

        if (allLocationDataRef.current.length === 0 || !allLocationDataRef.current[0]?.distanceKm) {
          await getAllLocationData(null, mapCords); // ✅ pass mapCords directly
        }

        let distanceData = await getHaulagePricingData(distanceDestinationObj, mapCords, geoLocations);
        if (distanceData) {
          distanceData = distanceData.sort((itemA, itemB) => itemA.index - itemB.index);
        }

        setHaulagePricingData(distanceData);

        let toAddArr = [
          'chipping',
          'doubleHandling',
          'haulage',
          'extractionCosts',
          'harvestingCostsPerTonne',
          'purchasesPrice',
        ];
        let finalObj = [];
        for (let i = 0; i < data.length; i++) {
          const backendHaulage = data[i]['haulage'];
          const hasBackendHaulage = backendHaulage !== null && backendHaulage !== undefined && backendHaulage !== 0;

          if (hasBackendHaulage) {
            data[i]['haulageManuallySet'] = true; // ← saved value = treat as manual, don't overwrite
          } else if (distanceData && distanceData[i] && distanceData[i]['fuelRate']) {
            let baseHaulage = distanceData[i]['fuelRate']['rateA'];
            let updatedDistance = ((obj.lpgRate - 1.2) / 1.2) * 0.4;
            data[i]['haulage'] = parseFloat(baseHaulage + updatedDistance * baseHaulage).toFixed(2);
            data[i]['haulageManuallySet'] = false;
          }

          let totalObj = {
            total: 0,
            totalHF: 0,
            totalProfit: 0,
            totalProfitPercentage: 0,
            totalPurchasePricePerProducts: 0,
            totalProfitPerProduct: 0,
            totalSalesPerProduct: 0,
            totalCostPerProductIncludingAll: 0,
            totalHFCostPerProduct: 0,
          };
          totalObj.total = toAddArr.reduce((prev, curr) => {
            return parseFloat(prev) + parseFloat(data[i][curr] ? data[i][curr] : 0);
          }, 0);
          totalObj.total = checkIfValidNum(totalObj.total?.toFixed(2));
          totalObj.totalHF = toAddArr
            ?.filter(item => item !== 'purchasesPrice')
            ?.reduce((prev, curr) => {
              return parseFloat(prev) + parseFloat(data[i][curr] ? data[i][curr] : 0);
            }, 0);
          totalObj.totalHF = checkIfValidNum(totalObj.totalHF?.toFixed(2));
          data[i]['salesPrice'] = checkIfValidNum(data[i]['salesPrice']);
          totalObj.totalProfit = (checkIfValidNum(data[i].salesPrice) - totalObj.total).toFixed(2);
          totalObj.totalProfitPercentage =
            data[i].salesPrice == 0 ? 0 : ((100 * totalObj.totalProfit) / data[i].salesPrice).toFixed(2);
          let currVol =
            parseFloat(obj.totalTons ? obj.totalTons : 0) *
            parseFloat(data[i]['productPercent'] ? data[i]['productPercent'] : 0);

          totalObj.totalPurchasePricePerProducts = (currVol * checkIfValidNum(data[i]['purchasesPrice'])) / 100;
          totalObj.totalSalesPerProduct = (currVol * checkIfValidNum(data[i]['salesPrice'])) / 100;
          totalObj.totalProfitPerProduct = (currVol * checkIfValidNum(totalObj.totalProfit)) / 100;
          totalObj.totalCostPerProductIncludingAll = (currVol * checkIfValidNum(totalObj.total)) / 100;

          totalObj.totalHFCostPerProduct = (currVol * checkIfValidNum(totalObj.totalHF)) / 100;

          totalObj.totalProfitPerProduct = formatter.format(totalObj.totalProfitPerProduct.toFixed(0));
          totalObj.totalPurchasePricePerProducts = formatter.format(totalObj.totalPurchasePricePerProducts.toFixed(0));
          totalObj.totalSalesPerProduct = formatter.format(totalObj.totalSalesPerProduct.toFixed(0));
          totalObj.totalCostPerProductIncludingAll = formatter.format(totalObj.totalCostPerProductIncludingAll.toFixed(0));
          totalObj.totalHFCostPerProduct = formatter.format(totalObj.totalHFCostPerProduct.toFixed(0));

          console.log(totalObj);
          data[i] = {
            ...data[i],
            ...totalObj,
          };
          console.log(finalObj);
          finalObj.push(data[i]);
        }

        setSalesPricingData(finalObj);

        const withHaulage = await fetchAndApplyHaulageRates(finalObj, allLocationDataRef.current);
        setSalesPricingData(withHaulage);
      }
    } catch (ex) {
      console.log(ex);
    }
  };

  useEffect(() => {
    if (allLocationData.length === 0) return;
    if (salesPricingData.length === 0) return;

    const applyHaulage = async () => {
      const withHaulage = await fetchAndApplyHaulageRates(salesPricingData, allLocationData);
      setSalesPricingData(withHaulage);
    };

    applyHaulage();
  }, [allLocationData]);

  const fetchAndApplyHaulageRates = async (pricingDataArr, locationData) => {
    const updatedData = [...pricingDataArr];

    await Promise.all(
      updatedData.map(async (row, colIndex) => {
        if (!row?.product) return;
        if (row?.haulageManuallySet) return; // ← SKIP manually edited rows

        const dest = row?.destination || row?.defaultDestination;
        const distanceKm = locationData.find(d => d.destinationName === dest)?.distanceKm ?? 0;
        const haulageCategoryId = row?.haulageCategory ?? 0;

        try {
          const payload = {
            distance: distanceKm,
            ...rateParams[0],
            haulageCategoryID: haulageCategoryId,
          };
          const { data } = await customAxios.post(`/Ops/GetCalculatedHaulageRates`, payload, { headers: authHeader() });

          updatedData[colIndex] = {
            ...updatedData[colIndex],
            haulage: parseFloat(data.actual_Rate ?? 0),
            haulageDetails: data,
          };
        } catch (err) {
          console.error(`Haulage rate fetch failed for col ${colIndex}:`, err);
        }
      }),
    );

    return updatedData;
  };

  const handleSalesPriceDataChange = async (name, value, index) => {
    console.log(name, value, index);
    let newHaulagedistance = null;
    if (name == 'destination') {
      console.log('selectedSiteInfo ===', selectedSiteInfo);
      let distanceData = await getHaulagePricingData(
        [
          {
            productsDestination: value,
          },
        ],
        selectedSiteInfo.mapCoordinates,
        selectedSiteInfo.geolocations,
      );
      if (distanceData && distanceData.length > 0) {
        distanceData = distanceData[0];
        newHaulagedistance = distanceData['fuelRate']['rateA'];
        let updatedDistance = ((siteAssesmentUpdateVariables.lpgRate - 1.2) / 1.2) * 0.4;
        newHaulagedistance = parseFloat(newHaulagedistance + updatedDistance * newHaulagedistance).toFixed(2);

        setHaulagePricingData(prev => {
          let oldData = [...prev];

          let getCurrentRecordIndex = oldData.find(item => item.index == index);
          console.log(getCurrentRecordIndex, 'newDes');
          if (getCurrentRecordIndex) {
            console.log('success');
            distanceData['index'] = index;
            oldData[getCurrentRecordIndex.index] = distanceData;
          } else {
            distanceData['index'] = index;
            oldData.push({ ...distanceData });
          }

          console.log('old data =====', oldData);

          return [...oldData];
        });
      }

      setSalesPricingData(prev => {
        const newData = [...prev];
        newData[index] = {
          ...newData[index],
          destination: value,
        };
        return newData;
      });

      const locInfo = getDistanceKmByName(value);
      // This will log the location and distance info
      const distanceKm = locInfo?.distanceKm ?? 0;
      const haulageCategoryId = salesPricingData[index]?.haulageCategory ?? 0;

      try {
        const payload = {
          distance: distanceKm,
          ...rateParams[0],
          haulageCategoryID: haulageCategoryId,
        };
        const { data } = await customAxios.post(`/Ops/GetCalculatedHaulageRates`, payload, { headers: authHeader() });
        setSalesPricingData(prev => {
          const newData = [...prev];
          newData[index] = {
            ...newData[index],
            destination: value,
            haulage: parseFloat(data.actual_Rate ?? 0),
            haulageDetails: data,
          };
          return newData;
        });
        handleSalesPriceDataChange('haulage', parseFloat(data.actual_Rate ?? 0), index);
      } catch (err) {
        console.error(`Haulage rate fetch failed for index ${index}:`, err);
      }

      return;
    }
    if (name === 'product') {
      setSalesPricingData(prev => {
        const oldData = [...prev];

        // If product removed → clear entire column
        if (!value) {
          oldData[index] = {};
          return oldData;
        }

        // If product added → normal behavior
        oldData[index] = {
          ...(oldData[index] || {}),
          product: value,
        };

        return oldData;
      });

      return;
    }

    setSalesPricingData(prev => {
      let updatedData = { ...prev[index] };
      let oldData = [...prev];
      updatedData[name] = value;
      if (newHaulagedistance) {
        updatedData['haulage'] = parseFloat(newHaulagedistance);
      }
      if (name === 'haulage') {
        updatedData['haulageManuallySet'] = true;
      }
      let toAddArr = [
        'chipping',
        'doubleHandling',
        'haulage',
        'extractionCosts',
        'harvestingCostsPerTonne',
        'purchasesPrice',
      ];
      let totalObj = {
        total: updatedData.total,
        totalHF: updatedData.totalHF,
        totalProfit: updatedData.totalProfit,
        totalProfitPercentage: updatedData.totalProfitPercentage,
        totalPurchasePricePerProducts: updatedData.totalPurchasePricePerProducts,
        totalProfitPerProduct: updatedData.totalProfitPerProduct,
        totalSalesPerProduct: updatedData.totalSalesPerProduct,
        totalCostPerProductIncludingAll: updatedData.totalCostPerProductIncludingAll,
        totalHFCostPerProduct: updatedData.totalHFCostPerProduct,
      };

      // if (name == 'extractionCosts' || name == 'harvestingCostsPerTonne') {
      //   //fillAll
      //   for (let i = 0; i < oldData.length; i++) {
      //     oldData[i][name] = value;
      //     totalObj.total = toAddArr.reduce((prev, curr) => {
      //       return parseFloat(prev) + parseFloat(oldData[i][curr] ? oldData[i][curr] : 0);
      //     }, 0);
      //     totalObj.total = totalObj.total?.toFixed(2);

      //     totalObj.totalProfit = (oldData[i].salesPrice - totalObj.total).toFixed(2);
      //     totalObj.totalProfitPercentage =
      //       oldData[i].salesPrice == 0 ? 0 : ((100 * totalObj.totalProfit) / oldData[i].salesPrice).toFixed(2);
      //     oldData[i] = { ...oldData[i], ...totalObj };
      //   }
      //   return [...oldData];
      // } else {
      totalObj.total = toAddArr.reduce((prev, curr) => {
        return parseFloat(prev) + parseFloat(updatedData[curr] ? updatedData[curr] : 0);
      }, 0);
      totalObj.total = checkIfValidNum(totalObj.total?.toFixed(2));
      totalObj.totalHF = toAddArr
        ?.filter(item => item !== 'purchasesPrice')
        ?.reduce((prev, curr) => {
          return parseFloat(prev) + parseFloat(updatedData[curr] ? updatedData[curr] : 0);
        }, 0);
      totalObj.totalHF = checkIfValidNum(totalObj.totalHF?.toFixed(2));
      totalObj.totalProfit = (checkIfValidNum(updatedData.salesPrice) - totalObj.total).toFixed(2);

      totalObj.totalProfitPercentage =
        updatedData.salesPrice == 0
          ? 0
          : ((100 * totalObj.totalProfit) / checkIfValidNum(updatedData.salesPrice)).toFixed(2);

      let toatalVol = siteAssesmentUpdateVariables.totalTons * checkIfValidNum(updatedData.productPercent);
      totalObj.totalPurchasePricePerProducts = (toatalVol * checkIfValidNum(updatedData.purchasesPrice)) / 100;
      totalObj.totalSalesPerProduct = (toatalVol * checkIfValidNum(updatedData.salesPrice)) / 100;
      totalObj.totalProfitPerProduct = (toatalVol * parseFloat(totalObj.totalProfit)) / 100;
      totalObj.totalCostPerProductIncludingAll = (toatalVol * parseFloat(totalObj.total)) / 100;

      totalObj.totalHFCostPerProduct = (toatalVol * checkIfValidNum(totalObj.totalHF)) / 100;

      totalObj.totalProfitPerProduct = formatter.format(totalObj.totalProfitPerProduct.toFixed(0));
      totalObj.totalPurchasePricePerProducts = formatter.format(totalObj.totalPurchasePricePerProducts.toFixed(0));
      totalObj.totalSalesPerProduct = formatter.format(totalObj.totalSalesPerProduct.toFixed(0));
      totalObj.totalCostPerProductIncludingAll = formatter.format(totalObj.totalCostPerProductIncludingAll.toFixed(0));
      totalObj.totalHFCostPerProduct = formatter.format(totalObj.totalHFCostPerProduct.toFixed(0));
      oldData[index] = { ...updatedData, ...totalObj };

      return [...oldData];
      // }
    });
  };
  const getAllSiteAssesments = () => {
    try {
      dispatch({ type: FETCH_START });
      customAxios.get('/CRM/GetCRMSiteDetails', { headers: authHeader() }).then(response => {
        let correctedData = response.data;

        setAllSiteAssesments(correctedData);
        dispatch({ type: FETCH_SUCCESS });
      });
    } catch (error) {
      setAllSiteAssesments([]);
      console.error('error', error);
      dispatch({ type: FETCH_ERROR, payload: 'Network Error' });
    }
  };

  const getSiteInfo = async () => {
    if (!selectedSiteAssesment) return;
    dispatch({ type: FETCH_START });

    const response = await customAxios.get(
      `/SiteDetails/GetSiteOptions/${selectedSiteAssesment.siteAssessmentID}/?mapType=pin`,
      {
        headers: authHeader(),
      },
    );

    if (response.status === 200) {
      let currData = response.data;
      dispatch({ type: FETCH_SUCCESS });
      setSelectedSiteInfo({ ...currData });
      setSelectedSiteProducts(currData.products);

      // ✅ Wait for locations to be loaded first
      if (!isLoadingLocations.current && allLocationData.length === 0) {
        isLoadingLocations.current = true;
        await getAllLocationData(); // This will populate allLocationData
        isLoadingLocations.current = false;
      }

      // ✅ Now get haulage data with populated allLocationData
      let distanceData = await getHaulagePricingData(currData.products, currData.mapCoordinates, currData.geolocations);

      if (distanceData) {
        distanceData = distanceData.sort((itemA, itemB) => itemA.index - itemB.index);
      }

      setHaulagePricingData(distanceData);

      if (currPricingVersion && currSiteAssessment) {
        fillEditSalesPriceTable(currData.mapCoordinates, currData.geolocations);
      } else {
        fillSalesPriceTableData(currData.products, distanceData);
      }
    } else {
      dispatch({ type: FETCH_ERROR, payload: 'Network Error' });
    }
  };

  const getHeaderInfoData = () => {
    if (!selectedSiteAssesment) return;
    console.log(selectedSiteAssesment);
    let hectares = selectedSiteAssesment.siteVolAreaInHa || 0;
    let treesPerHectare = selectedSiteAssesment.treesPerHectare || 0;
    let averageTree = selectedSiteAssesment.averageTree || 0;
    let conversionFactor = 1.15;
    let m3PerHectare = averageTree ? treesPerHectare * averageTree : 0;
    let tonnesPerHectare = conversionFactor ? m3PerHectare / conversionFactor : 0;
    let totalM3 = hectares ? m3PerHectare * hectares : 0;
    let totalTons = totalM3 / conversionFactor;

    let obj = {
      hectares: hectares,
      treesPerHectare: treesPerHectare, // m3PerHec /  conversionFactor
      averageTree: averageTree,
      conversionFactor: conversionFactor,
      m3PerHectare: m3PerHectare,
      tonnesPerHectare: tonnesPerHectare.toFixed(2),
      totalM3: totalM3.toFixed(2),
      totalTons: totalTons.toFixed(2),
      lpgRate: 1.2,
    };
    setSiteAssesmentVariables(obj);
    if (!currPricingVersion && !currSiteAssessment) {
      setSiteAssessmnetUpdateVariables(obj);
    }
    try {
    } catch (error) {
      console.error('Error fetching header info:', error);
    }
  };
  const checkIfValidNum = val => {
    return val && !isNaN(parseFloat(val)) ? parseFloat(val) : 0;
  };
  const handleSiteAssesmentVariableEdit = (name, value) => {
    try {
      if (!value) return;
      console.log(name, value, 'update');
      value = parseFloat(value);
      if (value < 0) {
        showToast('Value cannot be less than zero ', 'error');
        return;
      }
      if (name == 'lpgRate' || name == 'conversionFactor') {
        if (value > 2 || value < 1) {
          showToast('Please enter a number from 1 to 2', 'error');
          return;
        }
      }

      let oldVariableData = { ...siteAssesmentUpdateVariables };
      oldVariableData[name] = value;

      let hectares = oldVariableData.hectares || 0;
      let treesPerHectare = oldVariableData.treesPerHectare || 0;
      let averageTree = oldVariableData.averageTree || 0;
      let conversionFactor = oldVariableData.conversionFactor;

      let m3PerHectare = averageTree ? treesPerHectare * averageTree : 0;
      let tonnesPerHectare = conversionFactor ? m3PerHectare / conversionFactor : 0;
      let totalM3 = hectares ? m3PerHectare * hectares : 0;
      let totalTons = totalM3 / conversionFactor;

      let obj = {
        hectares: hectares,
        treesPerHectare: treesPerHectare, // m3PerHec /  conversionFactor
        averageTree: averageTree,
        conversionFactor: conversionFactor,
        m3PerHectare: m3PerHectare,
        tonnesPerHectare: tonnesPerHectare.toFixed(2),
        totalM3: totalM3.toFixed(2),
        totalTons: totalTons.toFixed(2),
        lpgRate: oldVariableData.lpgRate === 0 ? 1.2 : oldVariableData.lpgRate,
      };

      setSalesPricingData(prev => {
        let oldData = [...prev];
        let totalObj = {
          totalPurchasePricePerProducts: 0,
          totalProfitPerProduct: 0,
          totalSalesPerProduct: 0,
          totalCostPerProductIncludingAll: 0,
        };

        for (let i = 0; i < oldData.length; i++) {
          if (!oldData[i].product) continue;
          let updatedData = oldData[i];
          let totalVol = checkIfValidNum(totalTons) * checkIfValidNum(updatedData.productPercent);
          totalObj.totalPurchasePricePerProducts = (totalVol * checkIfValidNum(updatedData.purchasesPrice)) / 100;
          totalObj.totalSalesPerProduct = (totalVol * checkIfValidNum(updatedData.salesPrice)) / 100;
          totalObj.totalProfitPerProduct = (totalVol * checkIfValidNum(updatedData.totalProfit)) / 100;
          totalObj.totalCostPerProductIncludingAll = (totalVol * checkIfValidNum(updatedData.totalCosts)) / 100;

          totalObj.totalProfitPerProduct = formatter.format(totalObj.totalProfitPerProduct.toFixed(0));
          totalObj.totalPurchasePricePerProducts = formatter.format(totalObj.totalPurchasePricePerProducts.toFixed(0));
          totalObj.totalSalesPerProduct = formatter.format(totalObj.totalSalesPerProduct.toFixed(0));
          totalObj.totalCostPerProductIncludingAll = formatter.format(totalObj.totalCostPerProductIncludingAll.toFixed(0));
          oldData[i] = { ...oldData[i], ...totalObj };
        }
        return [...oldData];
      });

      setSiteAssessmnetUpdateVariables(obj);
    } catch (ex) {
      console.log(ex);
    }
  };
  const handleLPGRateEdit = newValue => {
    if (!newValue) return;
    newValue = parseFloat(newValue);
    if (newValue > 2 || newValue < 1) {
      showToast('Please enter a value between 1 and 2', 'error');
      return;
    }
    console.log(newValue, 'cval');
    setSalesPricingData(prev => {
      let oldData = [...prev];
      let totalObj = {
        total: 0,
        totalHF: 0,
        totalProfit: 0,
        totalProfitPercentage: 0,
        totalPurchasePricePerProducts: 0,
        totalProfitPerProduct: 0,
        totalSalesPerProduct: 0,
        totalCostPerProductIncludingAll: 0,
        totalHFCostPerProduct: 0,
      };
      let toAddArr = [
        'chipping',
        'doubleHandling',
        'haulage',
        'extractionCosts',
        'harvestingCostsPerTonne',
        'purchasesPrice',
      ];
      for (let i = 0; i < oldData.length; i++) {
        if (!oldData[i].product) continue;
        let updatedData = oldData[i];

        if (!haulagePricingData || haulagePricingData?.length === 0) {
          oldData[i]['haulage'] = 0;
          showToast('kindly add entrance drop pin to calculate haulage', 'error');
        } else {
          let currentHaulageData = haulagePricingData.filter(item => item.index == i);
          console.log(currentHaulageData, 'currentHaulageData');
          oldData[i]['haulage'] =
            currentHaulageData.length > 0 && currentHaulageData[0]['fuelRate']
              ? currentHaulageData[0]['fuelRate']['rateA'] * (((newValue - 1.2) / 1.2) * 0.4) +
                currentHaulageData[0]['fuelRate']['rateA']
              : 0;
        }

        oldData[i]['haulage'] = parseFloat(oldData[i]['haulage']).toFixed(2);

        totalObj.total = toAddArr.reduce((prev, curr) => {
          return parseFloat(prev) + parseFloat(oldData[i][curr] ? oldData[i][curr] : 0);
        }, 0);
        totalObj.total = totalObj.total?.toFixed(2);
        totalObj.totalProfit = (checkIfValidNum(oldData[i].salesPrice) - totalObj.total).toFixed(2);
        totalObj.totalProfitPercentage =
          oldData[i].salesPrice == 0
            ? 0
            : ((100 * totalObj.totalProfit) / checkIfValidNum(oldData[i].salesPrice)).toFixed(2);

        let totalVol = siteAssesmentUpdateVariables.totalTons * checkIfValidNum(updatedData.productPercent);
        totalObj.totalPurchasePricePerProducts = (totalVol * checkIfValidNum(updatedData.purchasesPrice)) / 100;
        totalObj.totalSalesPerProduct = (totalVol * checkIfValidNum(updatedData.salesPrice)) / 100;
        totalObj.totalProfitPerProduct = (totalVol * checkIfValidNum(totalObj.totalProfit)) / 100;
        totalObj.totalCostPerProductIncludingAll = (totalVol * checkIfValidNum(totalObj.total)) / 100;

        totalObj.totalHFCostPerProduct = (totalVol * checkIfValidNum(totalObj.totalHF)) / 100;

        totalObj.totalProfitPerProduct = formatter.format(totalObj.totalProfitPerProduct.toFixed(0));
        totalObj.totalPurchasePricePerProducts = formatter.format(totalObj.totalPurchasePricePerProducts.toFixed(0));
        totalObj.totalSalesPerProduct = formatter.format(totalObj.totalSalesPerProduct.toFixed(0));
        totalObj.totalCostPerProductIncludingAll = formatter.format(totalObj.totalCostPerProductIncludingAll.toFixed(0));
        totalObj.totalHFCostPerProduct = formatter.format(totalObj.totalHFCostPerProduct.toFixed(0));
        oldData[i] = { ...oldData[i], ...totalObj };
      }
      return [...oldData];

      // for (let i = 0; i < oldData.length; i++) {
      //   let newHaulageValue = haulagePricingData && haulagePricingData[i] && haulagePricingData[i]['fuelRate'];
      //   oldData[i]['haulage'] = newHaulageValue[newValue] || 0;
      // }
      // return [...oldData];
    });

    setSiteAssessmnetUpdateVariables(prev => {
      return {
        ...prev,
        lpgRate: newValue,
      };
    });
  };
  const handlePriceIpChange = (name, value, index) => {
    setSalesPricingData(prevstate => {
      let updatedData = { ...prevstate };
      updatedData[index][name] = value;
    });
  };
  const getNewPricingVersion = async siteAssessmentId => {
    return new Promise(res => {
      let url = '/Ops/NextTimberPricingVersion/' + siteAssessmentId;
      customAxios
        .get(url, { headers: authHeader() })
        .then(data => {
          console.log(data);
          if (data.status == 200) {
            res(data.data);
          } else {
            res(null);
          }
        })
        .catch(error => {
          res(null);
        });
    }).catch(reson => {
      return null;
    });
  };
  const getEntraceCoordinates = mapData => {
    let entraceCord = null;
    for (let i = 0; i < mapData.length; i++) {
      let item = mapData[i];
      if (item.mapLabel && item.mapLabel?.toLowerCase().startsWith('entrance')) {
        entraceCord = item;
        break;
      }
    }
    return entraceCord;
  };
  const getHaulagePricingData = async (products, mapCoordinates, geolocations) => {
    // ✅ Use ref instead of state
    const locationData = allLocationDataRef.current;

    if (locationData?.length === 0) {
      showToast('Unable to calculate haulage distance because no location data available.', 'error');
      return null;
    }

    console.log(mapCoordinates, geolocations, 'testing haulage');
    return new Promise(async res => {
      try {
        let entranceLink = geolocations.length > 0 ? geolocations[0]['entranceDropPinLink'] : null;
        let timberDropLink = geolocations.length > 0 ? geolocations[0]['timberDropPinLink'] : null;
        let entranceCord = getEntraceCoordinates(mapCoordinates);

        let startCordinated = entranceCord || entranceLink;

        if (!startCordinated) {
          showToast('Unable to calculate haulage distance because no entrance drop pin has been set.', 'error');
          res(null);
          return;
        }
        dispatch({ type: FETCH_START });

        if (entranceCord) {
          setEntranceMapcoordinates(entranceCord);
        }
        let haulageDistanceArr = [];
        for (let i = 0; i < products.length; i++) {
          let productDestination = products[i].productsDestination?.trim()?.toLowerCase();

          // ✅ Use locationData instead of allLocationData
          let destinatonCords = locationData.filter(
            item => item.destinationName?.trim()?.toLowerCase() == productDestination,
          );

          console.log('PRODUCTS ====', products, productDestination, locationData, destinatonCords);
          destinatonCords = destinatonCords.length > 0 ? destinatonCords[0] : null;

          let item = {
            index: i,
            start: {
              longitude: entranceCord ? entranceCord.longitude : null,
              latitude: entranceCord ? entranceCord.latitude : null,
            },
            end: {
              longitude: destinatonCords ? destinatonCords.longitude : null,
              latitude: destinatonCords ? destinatonCords.latitude : null,
            },
            startShortUrl: entranceCord ? null : entranceLink.replaceAll('"', ' '),
            endShortUrl: destinatonCords ? null : timberDropLink,
          };
          haulageDistanceArr.push(item);
        }

        console.log('HAULAGE DISTANCE ARR ===', haulageDistanceArr);
        const response = await customAxios.post('/Ops/CalculateFuelRates', haulageDistanceArr, { headers: authHeader() });
        dispatch({ type: FETCH_SUCCESS });

        if (response.status == 200) {
          res(response.data.results);
        } else {
          res(null);
        }
      } catch (ex) {
        dispatch({ type: FETCH_ERROR, payload: 'Error loading routes distance' });
        res(null);
      }
    });
  };
  // const savePricingData = async () => {
  //   const correctedPricingData = [];
  //   const nextVersion = await getNewPricingVersion(selectedSiteAssesment.siteAssessmentID);
  //   if (!nextVersion) {
  //     showToast('API Error: Cannot get new pricing version ', 'error');
  //     return;
  //   }
  //   let variableObj = {
  //     lpgRate: siteAssesmentUpdateVariables.lpgRate,
  //     hectares: siteAssesmentUpdateVariables.hectares,
  //     treesPerHectare: siteAssesmentUpdateVariables.treesPerHectare,
  //     avgTreeVol: siteAssesmentUpdateVariables.averageTree,
  //     conversionFactor: siteAssesmentUpdateVariables.conversionFactor,
  //     m3PerHectare: siteAssesmentUpdateVariables.m3PerHectare,
  //     tonnesPerHectare: siteAssesmentUpdateVariables.tonnesPerHectare,
  //     totalM3: siteAssesmentUpdateVariables.totalM3,
  //     totalTonnes: siteAssesmentUpdateVariables.totalTons,
  //   };
  //   for (let i = 0; i < salesPricingData.length; i++) {
  //     let item = salesPricingData[i];
  //     if (!item.product) continue;

  //     let currRowPer = item.productPercent || 0;
  //     item['pricingVersion'] = nextVersion;
  //     item['tonnes'] = ((siteAssesmentUpdateVariables.tonnesPerHectare * currRowPer) / 100).toFixed(0);
  //     item = { ...item, ...variableObj };
  //     correctedPricingData.push(item);
  //   }
  //   customAxios
  //     .post('/Ops/AddTimberPricing', correctedPricingData, { headers: authHeader() })
  //     .then(data => {
  //       if (data.status == 200) {
  //         if (data.data.total === data.data.success) {
  //           showToast('The pricing variant has been saved successfully', 'success');
  //           history.push('/timberSalesPricingList');
  //         } else {
  //           showToast('Error saving the pricing variant', 'error');
  //         }
  //       }
  //     })
  //     .catch(ex => {
  //       console.log(ex);
  //       showToast('Error saving the pricing variant ', 'error');
  //     });
  // };

  const handleProductDelete = index => {
    setProductConformationDialog(true);
    setCurrentProduct(index);
  };

  const closePricingVersion = () => {
    history.push('/timberSalesPricingList');
  };

  const savePricingData = async () => {
    // const correctedPricingData = [];

    if (!currPricingVersion && !currSiteAssessment) {
      showToast('Missing pricing version to update. Cannot save.', 'error');
      return;
    }

    // const res = await customAxios.get(
    //   `/Ops/GetTimberPricing/?siteAssessmentID=${currSiteAssessment}&pricingVersion=${currPricingVersion}`,
    //   { headers: authHeader() },
    // );
    // const spNumber = res.data[0].spNumber;

    // if (spNumber === '') {
    //   setCurrentSpNumber('zero');
    // } else {
    //   setCurrentSpNumber('tues');
    // }

    // if (spNumber) {
    //   showToast('❌ Can not edit pricing version, Please clone to edit');
    //   return;
    // }
    const variableObj = {
      lpgRate: siteAssesmentUpdateVariables.lpgRate,
      hectares: siteAssesmentUpdateVariables.hectares,
      treesPerHectare: siteAssesmentUpdateVariables.treesPerHectare,
      avgTreeVol: siteAssesmentUpdateVariables.averageTree,
      conversionFactor: siteAssesmentUpdateVariables.conversionFactor,
      m3PerHectare: siteAssesmentUpdateVariables.m3PerHectare,
      tonnesPerHectare: siteAssesmentUpdateVariables.tonnesPerHectare,
      totalM3: siteAssesmentUpdateVariables.totalM3,
      totalTonnes: siteAssesmentUpdateVariables.totalTons,
    };
    // let CompartmentName = '';
    // for (let i = 0; i < salesPricingData.length; i++) {
    //   let item = salesPricingData[i];
    //   if (!item.product) continue;

    //   const currRowPer = item.productPercent || 0;
    //   item['siteAssessmentID'] = currSiteAssessment;
    //   item['pricingVersion'] = currPricingVersion; // <-- Use passed version
    //   const url = `/Ops/GetTimberPricing?siteAssessmentID=${currSiteAssessment}&sPNumber=&pricingVersion=${currPricingVersion}`;
    //   const response = await customAxios.get(url, { headers: authHeader() });
    //   item['timberPricingLabel'] = response.data[0].timberPricingLabel || '';
    //   item['spNumber'] = response.data[0].spNumber || '';
    //   item['subCompartmentName'] = response.data[0].subCompartmentName || null;
    //   item['tonnes'] = ((siteAssesmentUpdateVariables.tonnesPerHectare * currRowPer) / 100).toFixed(0);
    //   item = { ...item, ...variableObj };
    //   CompartmentName = response.data[0].subCompartmentName || null;
    //   correctedPricingData.push(item);
    // }

    // const payload = {
    //   siteAssessmentID: currSiteAssessment,
    //   pricingVersion: currPricingVersion,
    //   subCompartmentName: CompartmentName,
    // };

    let CompartmentName = '';
    const correctedPricingData = [];

    const url = `/Ops/GetTimberPricing?siteAssessmentID=${currSiteAssessment}&sPNumber=&pricingVersion=${currPricingVersion}`;
    const { data: pricingData } = await customAxios.get(url, { headers: authHeader() });

    // Handle empty or malformed response gracefully
    if (!Array.isArray(pricingData) || pricingData.length === 0) {
      throw new Error('Timber pricing data not found.');
    }

    // Set CompartmentName once (from the first entry)
    // CompartmentName = pricingData[0].subCompartmentName || '';

    for (let i = 0; i < salesPricingData.length; i++) {
      const item = salesPricingData[i];
      if (!item.product) continue;

      const currRowPer = item.productPercent || 0;

      const updatedItem = {
        ...item,
        siteAssessmentID: currSiteAssessment,
        pricingVersion: currPricingVersion,
        timberPricingLabel: pricingData[0].timberPricingLabel || '',
        spNumber: pricingData[0].spNumber || '',
        // subCompartmentName: pricingData[0].subCompartmentName || '',
        tonnes: Math.round((siteAssesmentUpdateVariables.tonnesPerHectare * currRowPer) / 100),
        ...variableObj,
      };

      correctedPricingData.push(updatedItem);
    }

    try {
      const rawData = {
        recordDateTime: toLocalISO(),
        syncType: 'Timber Pricing',
        jsonData: JSON.stringify(correctedPricingData, null, 2),
      };
      await customAxios.post(`CRM/AddAppRawData`, rawData, { headers: authHeader() });
    } catch (error) {
      console.log(error);
    }

    const payload = {
      siteAssessmentID: currSiteAssessment,
      pricingVersion: currPricingVersion,
      // subCompartmentName: CompartmentName,
    };

    await customAxios.post('/Ops/DeleteTimberPricing', payload, {
      headers: authHeader(),
    });

    customAxios
      .post('/Ops/AddTimberPricing', correctedPricingData, { headers: authHeader() })
      .then(data => {
        if (data.status === 200) {
          if (data.data.total === data.data.success) {
            showToast('The pricing variant has been saved successfully', 'success');
            // history.push('/timberSalesPricingList');
          } else {
            showToast('Error saving the pricing variant', 'error');
          }
        }
      })
      .catch(ex => {
        console.log(ex);
        showToast('Error saving the pricing variant ', 'error');
      });
  };

  const calculateTotalProductPercent = () => {
    let total = 0;
    for (let i = 0; i < salesPricingData.length; i++) {
      if (salesPricingData[i]?.product) {
        total += parseFloat(salesPricingData[i].productPercent) || 0;
      }
    }
    return total.toFixed(2);
  };

  const approveAllRoutes = async () => {
    try {
      dispatch({ type: FETCH_START });

      const entrance = getEntrance(selectedSiteInfo?.mapCoordinates);
      if (!entrance) {
        showToast('No entrance drop pin found. Please set one in the map.', 'error');
        dispatch({ type: FETCH_SUCCESS });
        return;
      }

      await loadGoogleMaps();

      // Collect unique destinations that don't have a saved route yet
      const pendingDestinations = [];
      const seen = new Set();

      for (const row of salesPricingData) {
        const dest = row?.destination || row?.defaultDestination;
        if (!dest || seen.has(dest)) continue;

        const locData = allLocationData.find(l => l.destinationName === dest);
        if (!locData || locData.distanceSource === 'route') continue; // already saved

        seen.add(dest);
        pendingDestinations.push({ dest, locData });
      }

      if (pendingDestinations.length === 0) {
        showToast('All routes are already saved.', 'success');
        dispatch({ type: FETCH_SUCCESS });
        return;
      }

      const directionsService = new window.google.maps.DirectionsService();

      for (const { dest, locData } of pendingDestinations) {
        const destLat = Number(locData.latitude);
        const destLng = Number(locData.longitude);

        if (!Number.isFinite(destLat) || !Number.isFinite(destLng)) continue;

        await new Promise(resolve => {
          directionsService.route(
            {
              origin: entrance,
              destination: { lat: destLat, lng: destLng },
              travelMode: window.google.maps.TravelMode.DRIVING,
            },
            async (result, status) => {
              if (status !== 'OK') {
                console.warn(`Route failed for ${dest}: ${status}`);
                resolve();
                return;
              }

              const route = result.routes[0];
              const distanceKm = parseFloat((route.legs[0].distance.value / 1000).toFixed(1));
              const polyLine = route.overview_polyline;

              const obj = {
                siteAssessmentID: currSiteAssessment,
                destination: dest,
                distance: distanceKm,
                polyLine,
                entrance: 'entrance',
                entranceLatitude: entrance.lat,
                entranceLongitude: entrance.lng,
                destinationLatitude: destLat,
                destinationLongitude: destLng,
              };

              try {
                await customAxios.post('/SiteDetails/AddSiteDetailsMapRoutes', obj, { headers: authHeader() });
              } catch (err) {
                console.error(`Failed to save route for ${dest}:`, err);
              }

              resolve();
            },
          );
        });
      }

      // Refresh location data so distanceSource updates to 'route'
      await getAllLocationData();
      showToast('All routes approved and saved successfully.', 'success');
      dispatch({ type: FETCH_SUCCESS });
    } catch (ex) {
      console.error(ex);
      dispatch({ type: FETCH_ERROR, payload: 'Error approving routes' });
    }
  };

  const openDrawer = () => setShowPrevVersions(true);
  const closeDrawer = () => setShowPrevVersions(false);

  return {
    savePricingData,
    handlePriceIpChange,
    openConfirmationDialog,
    setOpenConfirmationDialog,
    handleOpenConfirmationDialog,
    confirmationDialogProps,
    closeConfirmationDialog,
    allSiteAssesments,
    selectedSiteAssesment,
    setSeletedSiteAssesment,
    siteAssessmentVariables,
    selectedSiteInfo,
    setSelectedSiteInfo,
    selectedSiteProducts,
    setSelectedSiteProducts,
    salesPricingData,
    setSalesPricingData,
    handleSalesPriceDataChange,
    handleLPGRateEdit,
    siteAssesmentUpdateVariables,
    setSiteAssessmnetUpdateVariables,
    handleSiteAssesmentVariableEdit,
    productListOptions,
    fullPriceForSite,
    closePricingVersion,
    handleProductDelete,
    productConformationDialog,
    setProductConformationDialog,
    currentProduct,
    allLocationData,
    currentSpNumber,
    getDistanceKmByName,
    showPrevVersions,
    openDrawer,
    closeDrawer,
    prevVersions,
    calculateTotalProductPercent,
    approveAllRoutes,
    haulgeCategoryOptions,
    handleHaulageCategoryChange,
    rateParams,
  };
};

export default useTimberSalesPriceController;
